export const boostSharedAU = {
  tagInfo: {
    heading: 'Popular badges',
    description:
      'Our popular suggestions are general in nature and do not take into account your individual circumstances.<br/><br/>These are based on volume of Freely policies sold to customers in Australia over the past calendar year.<br/><br/>Please carefully consider your own situation and read the PDS to determine if this product is right for you.',
  },
  info: 'What does popular mean?',
  payPerDayModal: {
    cruiseCoverPopUp: {
      calendarTitle: 'Which days will you be on your cruise?',
      notificationTitleMobile: `You must add our Cruise Cover Boost to be covered for cruising. You'll see this added to your policy on the next page.`,
      notificationTitle:
        "If your cruise is 2 or more nights, you must add our Cruise Cover Boost to be covered. You'll see this added to your policy on the next page.",
    },
    notification: {
      title: 'You can now add multiple dates',
      body: 'Either select a range of dates you need cover for, or double tap to select any single days',
    },
  },
  excess: {
    description: {
      domestic:
        'Excess is the initial amount deducted from the total of an approved claim before we reimburse you. Domestic travel has a  **${{excessValue}}** excess.',
      international:
        'Excess is the initial amount deducted from the total of an approved claim before we reimburse you.',
    },
    modal: {
      content:
        "Domestic travel has a $50 excess. For international travel, you can select an excess of $100, $200, or $300 for your policy. <br/><br/>The excess amount you choose applies per applicable event. By 'event' we mean: If you fall over and break both your wrist and phone and lodge a claim under two benefits (Overseas Medical Expenses and Luggage and Travel Documents), the excess will only be deducted once. <br/><br/>When a claim relates to you or your travelling companion contracting COVID-19, we will deduct $500 for international travel claims and $250 for domestic travel claims from the total amount reimbursed. <br/><br/>Your chosen excess amount will be shown on your Certificate of Insurance and only applies in the event of a claim.",
    },
  },
};
